import { useEffect, useState } from 'react'

import { Button, Modal, Trans } from '@/components'
import { ExpirationBehavior } from '@/pages/create-instance/components/ExpirationBehavior'

interface ExpirationBehaviorModalProps {
  open: boolean
  value: boolean
  submitting?: boolean
  onClose: () => void
  onConfirm: (value: boolean) => void | Promise<void>
}

export function ExpirationBehaviorModal({
  open,
  value,
  submitting = false,
  onClose,
  onConfirm,
}: ExpirationBehaviorModalProps) {
  const [draftValue, setDraftValue] = useState(value)

  useEffect(() => {
    if (open) setDraftValue(value)
  }, [open, value])

  return (
    <Modal open={open} onClose={submitting ? undefined : onClose} className="w-[640px]">
      <Modal.Header>
        <Trans i18nKey="instance.detail.billing.expirationBehavior">Expiration Behavior</Trans>
      </Modal.Header>
      <Modal.Body>
        <ExpirationBehavior value={draftValue} onChange={setDraftValue} className="w-full" />
      </Modal.Body>
      <Modal.Footer>
        <Button type="outline" disabled={submitting} onClick={onClose}>
          <Trans i18nKey="common.confirmModalCancel">Cancel</Trans>
        </Button>
        <Button
          type="secondary"
          disabled={submitting || draftValue === value}
          onClick={() => onConfirm(draftValue)}
        >
          <Trans i18nKey="common.confirm">Confirm</Trans>
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
